import React from "react";
import PropTypes from "prop-types";
import imageMuurKlampVisible from "../../../images/situation/maten/muur/Yzichtbaar.jpg";
import imageMuurKlamp from "../../../images/situation/maten/muur/Ynietzichtbaar.jpg";
import imageKozijnKlampVisible from "../../../images/situation/maten/kozijn/Yzichtbaar.jpg";
import imageKozijnKlamp from "../../../images/situation/maten/kozijn/Ynietzichtbaar.jpg";

MaatY.propTypes = {
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired,
    isMuurMontage: PropTypes.bool.isRequired,
    onEnter: PropTypes.func.isRequired,
    klampen: PropTypes.oneOf("none", "visible", "invisible").isRequired,
}
export default function MaatY(props) {
    let image;
    if (props.isMuurMontage) {
        switch (props.klampen) {
            case "visible":
                image = imageMuurKlampVisible;
                break;
            default:
                image = imageMuurKlamp;
                break;
        }
    } else {
        switch (props.klampen) {
            case "visible":
                image = imageKozijnKlampVisible;
                break;
            default:
                image = imageKozijnKlamp;
                break;
        }
    }
    return <div className="phone-page-middle">
        <div className="phone-situation-title">
            Vul hier de dikte van de klamp in, in milimeters.<br/>
        </div>
        <input
            className="phoneInput"
            onChange={props.onChange}
            value={props.value}
            type="number"
            inputMode="numeric"
            onKeyDown={event => event.key === 'Enter' ? props.onEnter() : null}
            placeholder="Vul hier de maat in..."
        />
        <img className="explainImagePhone" src={image} alt=""/>
    </div>;
}